import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollLock() {
  const location = useLocation();

  useEffect(() => {
    const lockPaths = ["/login", "/signup"];

    if (lockPaths.includes(location.pathname)) {
      document.body.classList.add("lock-scroll");
    } else {
      document.body.classList.remove("lock-scroll");
    }
  }, [location.pathname]);

  return null;
}
